// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"581e79f8","139":"fdef9c60","181":"acaae624","442":"c5acd5af","519":"4ea6ebf4","670":"d7255902","696":"e0dac41a","824":"dc7a513e","960":"4ad22804"}[chunkId] + ".chunk.js";
};